import React from "react";
import { Fade } from "@material-ui/core";

import DiceBox from "components/Dice/DiceBox/DiceBox";

function DiceRollScreen(props) {
  return (
    <Fade style={{}}>
      <DiceBox closeSpeedDial={props.closeSpeedDial} />
    </Fade>
  );
}

export default DiceRollScreen;
